import React, { useEffect, useState } from "react";
import { FiVideo } from "react-icons/fi";
import { useNavigate } from "react-router-dom";

import VideoProviderSelector from "./VideoProviderSelector";
import ZoomAuthSection from "./AuthSection/ZoomAuthSection";
import GoogleAuthSection from "./AuthSection/GoogleAuthSection";
import MeetingSection from "./MeetingSection";

import { getProvider } from "./Providers";
import { setZoomAuth } from "./Auth/ZoomAuthHelper";
import { setGoogleAuth } from "./Auth/GoogleMeetAuthHelper";


import "../../assets/css/VideoConference.css";

export default function VideoConference() {
  const navigate = useNavigate();

  //  REQUIRED STATES
  const [provider, setProvider] = useState("zoom");
  const [isConnected, setIsConnected] = useState(false);

  useEffect(() => {
    const appToken = localStorage.getItem("accessToken");
    if (!appToken) {
      navigate("/signin");
      return;
    }

    const providerApi = getProvider(provider);
    //  Validate provider token on page load or provider change, then clean expired meetings.
    (async () => {
      try {
        const token = await providerApi.getValidAccessToken();
        setIsConnected(!!token);

        if (token) {
          await providerApi.deleteExpiredMeetings(token);
        }
      } catch (err) {
        setIsConnected(false);
      }
    })();

    //  OAuth popup listener
    const handler = async (e) => {
      const token = e.data?.token;

      if (e.data?.type === "ZOOM_OAUTH_SUCCESS" && token?.access_token) {
        setZoomAuth(token);
        setIsConnected(true);

        try {
          await getProvider("zoom").deleteExpiredMeetings(token.access_token);
        } catch (err) {
          console.error("Failed to delete expired Zoom meetings", err);
        }
      }

      if (e.data?.type === "GOOGLE_OAUTH_SUCCESS" && token?.access_token) {
        setGoogleAuth(token);
        setIsConnected(true);

        try {
          await getProvider("google").deleteExpiredMeetings(token.access_token);
        } catch (err) {
          console.error("Failed to delete expired Google Meet meetings", err);
        }
      }
    };

    window.addEventListener("message", handler);
    return () => window.removeEventListener("message", handler);
  }, [provider, navigate]);

  return (
    <div className="video-conference-wrapper">
      <h5 className="video-conference-title page-title">
        <FiVideo /> Video Conference
      </h5>
      <p className="page-subtitle">Schedule and manage meetings across multiple platforms</p>

      {/* 1 Provider Selection */}
      {!isConnected && (
        <VideoProviderSelector
          provider={provider}
          setProvider={setProvider}
        />
      )}

      {/* 2 Authentication */}
      {provider === "zoom" && <ZoomAuthSection />}
      {provider === "google" && <GoogleAuthSection />}

      {/* 3 Meeting UI */}
      {isConnected && <MeetingSection providerKey={provider} />}
    </div>
  );
}
